import axios from 'axios';

const BASE_URL_FUNNEL = '/app/emailFunnel';

export const createLegacyEmail = async (emailTitle) => {
    const { data } = await axios.post(`${BASE_URL_FUNNEL}`, emailTitle, {
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
        },
    });

    return data;
};

export const updateLegacyEmail = async (marketingEmailId, payload) => {
    await axios.put(`${BASE_URL_FUNNEL}/${marketingEmailId}`, payload, {
        headers: {
            'Content-Type': 'application/json;charset=UTF-8',
        },
    });
};
